import { Component, OnDestroy } from '@angular/core';
import {
  getAllJobs,
  getDashboardReportsSelect,
} from '@modules/reports/store/referral-reports.selectors';
import { Store } from '@ngrx/store';
import {
  loadAllJobsByParams,
  loadAveragesPerJob,
  loadAvgResponseTime,
  loadDashboardReports,
  loadDashboardReportsOffer,
  loadDashboardReportsSubmissions,
  loadJobDepartments,
} from '@modules/reports/store/referral-reports.actions';
import { JobsPageFilterType } from '@modules/jobs-page/store/filter/filter.reducer';
import { Subscription } from 'rxjs';
import { DEFAULT_JOB_STATUS_FILTER } from '@shared/models/job-statuses';
import { Subpages } from '@modules/reports/models/subpages';
import {
  allDepartments,
  allFunctions,
} from '@modules/reports/models/all-functions-and-departments';
import { ReferralReportsFilters } from '@modules/reports/models/referral-reports-filters';

@Component({
  selector: 'mojo-reports-dashboard',
  styleUrls: ['./dashboard.container.scss'],
  templateUrl: './dashboard.container.html',
})
export class DashboardContainerComponent implements OnDestroy {
  constructor(private store: Store<{}>) {}

  selectAllJobs$ = this.store.select(getAllJobs);
  selectReportsDashboard$ = this.store.select(getDashboardReportsSelect);

  sub: Subscription = new Subscription();

  params = {
    jobAssignedTo: JobsPageFilterType.ALL,
    offset: 0,
    status: DEFAULT_JOB_STATUS_FILTER,
    jobFunction: JobsPageFilterType.ALL,
    jobDepartment: JobsPageFilterType.ALL,
    searchByRecruiter: '',
  };

  changeJobStatusFilter(status) {
    this.params = { ...this.params, status };
    this.pageChange(0);
    this.loadFunctions(this.params.jobFunction, status);
  }

  changeFunctionAndDepartment(obj) {
    this.params = {
      ...this.params,
      jobFunction:
        obj.selectedFunction === allFunctions ? JobsPageFilterType.ALL : obj.selectedFunction,
      jobDepartment:
        obj.selectedDepartment === allDepartments ? JobsPageFilterType.ALL : obj.selectedDepartment,
    };
    this.pageChange(0);
    this.loadFunctions(obj.selectedFunction, this.params.status);
  }

  loadFunctions(jobFunction, jobStatus) {
    this.store.dispatch(
      loadJobDepartments({
        filters: {
          jobFunction: this.mapFunctionOrDepartment(false),
          jobStatus,
        },
        departmentsPage: Subpages.PIPELINE,
      }),
    );

    const paramsChar: ReferralReportsFilters = {
      jobDepartment:
        this.params.jobDepartment === JobsPageFilterType.ALL
          ? allDepartments
          : this.params.jobDepartment,
      jobFunction: jobFunction === JobsPageFilterType.ALL ? allFunctions : jobFunction,
      jobStatus,
    };

    this.store.dispatch(loadDashboardReports({ filters: paramsChar }));
    this.store.dispatch(loadDashboardReportsSubmissions({ filters: paramsChar }));
    this.store.dispatch(loadDashboardReportsOffer({ filters: paramsChar }));
    this.loadAveragesPerJob();
  }

  loadAveragesPerJob() {
    this.store.dispatch(
      loadAveragesPerJob({
        params: {
          jobFunction: this.mapFunctionOrDepartment(false),
          jobDepartment: this.mapFunctionOrDepartment(true),
          jobStatus: this.params.status,
          searchByRecruiter: this.params.searchByRecruiter,
        },
      }),
    );
  }
  pageChange(offset: number): void {
    this.store.dispatch(
      loadAllJobsByParams({
        params: { ...this.params, offset },
      }),
    );
    this.sub.add(
      this.store.select(getAllJobs).subscribe((allJobs) => {
        const ids = allJobs.content.map((job) => job.id);
        this.store.dispatch(loadAvgResponseTime({ jobIds: ids }));
      }),
    );
  }

  mapFunctionOrDepartment(isDepartmentMapping) {
    const allValue = isDepartmentMapping ? allDepartments : allFunctions;
    const currentValue = isDepartmentMapping ? this.params.jobDepartment : this.params.jobFunction;
    return currentValue === JobsPageFilterType.ALL ? allValue : currentValue;
  }

  changeCandidateOrHiringManager(selectedCandidateOrHiringManager) {
    this.params = {
      ...this.params,
      searchByRecruiter: selectedCandidateOrHiringManager,
    };

    this.pageChange(0);
    this.loadAveragesPerJob();
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
